const STORAGE_KEY = "hourlyCartEventType";

export const HOURLY_CART_CATEGORY_EVENT = "hourlyCartCategoryUpdated";

export const getCachedHourlyEventType = () =>
  sessionStorage.getItem(STORAGE_KEY) || "";

export const setCachedHourlyEventType = (value) => {
  const normalized = String(value || "").trim();
  if (normalized) {
    sessionStorage.setItem(STORAGE_KEY, normalized);
  } else {
    sessionStorage.removeItem(STORAGE_KEY);
  }
};

export const notifyHourlyEventTypeChange = (eventType) => {
  window.dispatchEvent(
    new CustomEvent(HOURLY_CART_CATEGORY_EVENT, {
      detail: { eventType: String(eventType || "").trim() },
    })
  );
};
